import React, { FC } from 'react';

import { Checkbox, Form } from 'antd';

// Styles
import './consultation-type.scss';

type TTotalInfoProps = {};

export const ConsultationType: FC<TTotalInfoProps> = (
  {}: TTotalInfoProps
): JSX.Element => {

  const defaults = ['show_calls', 'show_audio_calls', 'show_messages', 'show_conversations'];

  const options = [
    { value: 'show_calls', label: 'Video Consultation' },
    { value: 'show_audio_calls', label: 'Voice Consultation' },
    { value: 'show_messages', label: 'Correspondence' },
    { value: 'show_conversations', label: 'Text Chat' },
  ];

  return (
    <div className={ `consultation-type` }>
      <Form.Item name={ 'types' } initialValue={ defaults }>
        <Checkbox.Group options={ options }/>
      </Form.Item>
    </div>
  );
};
